<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="modal fixed inset-0 w-full h-screen flex items-center justify-center h-full"
      @click.self="close"
    >
      <div :class="divClasses">
        <button
          v-if="backdrop"
          type="button"
          aria-label="close"
          class="flex items-center cursor-pointer justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 bg-gray-100 text-gray-600 hover:bg-gray-200"
          @click.prevent="close"
        >
          <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            class="fill-current h-4 w-4"
          >
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            ></path>
          </svg>
        </button>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: "max-w-4xl",
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  computed: {
    divClasses() {
      return [
        this.maxWidth,
        "relative w-full bg-white shadow-lg rounded-lg p-4",
      ];
    },
  },
  methods: {
    close() {
      if (this.$props.backdrop) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
